import script from "./BetInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BetInput.vue?vue&type=script&setup=true&lang=js"

import "./BetInput.vue?vue&type=style&index=0&id=b0f119b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0f119b4"]])

export default __exports__